export default "__VITE_ASSET__uT5QMFU___"